import {Action} from '@ngrx/store';
import {Tenant} from '@app/core/models/tenant.model';
import {User} from '@app/core/models/user.model';
import {Department} from '@app/core/models/department.model';
import {EINTEGRATIONSMODEL} from '@app/core/enums';
import {Integration} from '@app/core/models/integration.model';
import {IPosIntegrationModel} from '@app/core/models/quickpos-integration.model';

export enum EIntegrationsActions {
	GetPaymentNumberModelsWithUsers = '[Integrations] Get Payment Number Models With Users',
	GetPaymentNumberModelsWithDepartments = '[Integrations] Get Payment Number Models With Departments',
	GetPaymentNumberModelsSuccess = '[Integrations] Get Payment Number Models Success',

	ActivateIntegration = '[Integration] Activate integration',
	ActivateIntegrationSuccess = '[Integration] Activate integration success',

	RemoveIntegration = '[Integration] Remove integration',
	RemoveIntegrationSuccess = '[Integration] Remove integration success',

	PatchIntegration = '[Integrations] Save integration',
	PatchIntegrationSuccess = '[Integrations] Save integration success',

	GetQuickPosIntegration = '[Integrations] Get QuickPos Integration',
	GetQuickPosIntegrationSuccess = '[Integrations] Get QuickPos Integration Success',
	PatchQuickPosIntegration = '[Integrations] Patch QuickPos Integration',
	PatchQuickPosIntegrationSuccess = '[Integrations] Patch QuickPos Integration Success',
}

export class GetPaymentNumberModelsWithUsers implements Action {
	public readonly type = EIntegrationsActions.GetPaymentNumberModelsWithUsers;

	constructor() {
	}
}

export class GetPaymentNumberModelsWithDepartments implements Action {
	public readonly type = EIntegrationsActions.GetPaymentNumberModelsWithDepartments;

	constructor() {
	}
}

export class GetPaymentNumberModelsSuccess implements Action {
	public readonly type = EIntegrationsActions.GetPaymentNumberModelsSuccess;

	constructor(public tenant: Tenant, public paymentNumberModels: User[] | Department[]) {
	}
}

export class ActivateIntegration implements Action {
	public readonly type = EIntegrationsActions.ActivateIntegration;

	constructor(public integration: Integration) {
	}
}

export class ActivateIntegrationSuccess implements Action {
	public readonly type = EIntegrationsActions.ActivateIntegrationSuccess;

	constructor(public integration: Integration) {
	}
}

export class RemoveIntegration implements Action {
	public readonly type = EIntegrationsActions.RemoveIntegration;

	constructor() {
	}
}

export class RemoveIntegrationSuccess implements Action {
	public readonly type = EIntegrationsActions.RemoveIntegrationSuccess;

	constructor() {
	}
}

export class PatchIntegration implements Action {
	public readonly type = EIntegrationsActions.PatchIntegration;

	constructor(public paymentNumberModels: User[] | Department[], public paymentNumberModel: EINTEGRATIONSMODEL, public redirect: boolean) {
	}
}

export class PatchIntegrationSuccess implements Action {
	public readonly type = EIntegrationsActions.PatchIntegrationSuccess;

	constructor() {
	}
}

export class GetQuickPosIntegration implements Action {
	public readonly type = EIntegrationsActions.GetQuickPosIntegration;

	constructor() {
	}
}

export class GetQuickPosIntegrationSuccess implements Action {
	public readonly type = EIntegrationsActions.GetQuickPosIntegrationSuccess;

	constructor(public integration: IPosIntegrationModel) {
	}
}

export class PatchQuickPosIntegration implements Action {
	public readonly type = EIntegrationsActions.PatchQuickPosIntegration;

	constructor(public integration: IPosIntegrationModel) {
	}
}

export class PatchQuickPosIntegrationSuccess implements Action {
	public readonly type = EIntegrationsActions.PatchQuickPosIntegrationSuccess;

	constructor(public integration: IPosIntegrationModel) {
	}
}

export type IntegrationsActions =
	GetPaymentNumberModelsWithUsers |
	GetPaymentNumberModelsWithDepartments |
	GetPaymentNumberModelsSuccess |
	ActivateIntegration |
	ActivateIntegrationSuccess |
	RemoveIntegration |
	RemoveIntegrationSuccess |
	PatchIntegration |
	PatchIntegrationSuccess |
	PatchQuickPosIntegration |
	PatchQuickPosIntegrationSuccess |
	GetQuickPosIntegration |
	GetQuickPosIntegrationSuccess
	;
